/**
 * Global application providers.
 */
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/app/providers/AuthProvider';

/** @param {{children: React.ReactNode}} props */
export function AppProviders({ children }) {
	return (
		<BrowserRouter>
			<AuthProvider>
				{children}
				<Toaster position="top-right" richColors />
			</AuthProvider>
		</BrowserRouter>
	);
}

export default AppProviders;
